import shortSellModal from "./../../components/Dialogs/confirmationModal";
import errorSymbolModal from "./../../components/Dialogs/confirmationModal";
// import ckycmodal from './../../components/Dialogs/CKYCModal.vue'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { parse } from "json2csv";
import { API_URL } from "../../../config";
import { isTokenValid, setInputFilter, createCSV } from "../../utils/util";
import { announceToScreenReader } from "@/utils/screenReaderAnnounce";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";

const _parseBuyPrice = (value) => {
  const raw = (value ?? "")
    .toString()
    .trim()
    .replace(/^\uFEFF/, "")
    .replace(/^"|"$/g, "");
  if (!raw) return "";
  const num = Number(raw);
  return Number.isFinite(num) ? num.toFixed(2).toString() : "";
};

// Back-compat: some compiled call sites may reference `parseBuyPrice(...)` directly.
const parseBuyPrice = _parseBuyPrice;
import {
  PSI_LOGIN,
  GENERATE_REPORT,
  AUTO_SUGGEST_SYMBOLS,
  GET_SYMBOL_PRICE,
  GET_INSTRUMENT_ID,
  GET_USER_SUBSCRIPTION,
  GET_BROKER_USER_HOLDINGS,
  GET_BROKER_ADMIN_USER_HOLDINGS,
  UPDATE_SUBSCRIPTION,
  USER_LOGOUT,
  GET_USER_BROKER_TOKEN,
  GET_BROKER_ADMIN_TOKEN,
  CHECK_REGISTERED_BROKER_USER,
  CHECK_USER_CKYC,
  GET_LEGAL_AGREEMENT,
  SAVE_LEGAL_AGREEMENT,
  POST_PDF_DOWNLOAD_SUCCESS,
  UPDATE_POST_PDF_DOWNLOAD_SUCCESS,
  GET_USER_LAST_REPORT,
  GET_ACTIVE_MSI_PORTFOLIO,
  GET_MS_TRANSACTION_HISTORY,
  VALIDATE_HOLIDAY_DATE,
  STANDARD_CHARTEREDDATA_GENERATE_REPORT,
} from "./../../store/actions.type";
import {
  getJWTFromStorage,
  removeJWTFromStorage,
  saveJWTToStorage,
} from "@/api/localStorage";
import { data } from "jquery";
import legalagreementpopup from "./../../components/legalagreementpopup.vue";
import { result } from "lodash";
import { debounce } from "debounce";
import symbolSuggestionKeyboard from "./symbolSuggestionKeyboard";
import { applyDatepickerToggleAriaLabels } from "@/utils/datepickerAccessibility";
import axios from "axios";
import { valid } from "semver";

export default {
  name: "ImportHoldings",
  mixins: [validationMixin, symbolSuggestionKeyboard],
  components: {
    FontAwesomeIcon,
    shortSellModal,
    errorSymbolModal,
    legalagreementpopup,
  },
  data() {
    return {
      selectedBroker: 5,
      brokers: [
        // { value: 1, text: "5Paisa" },
        // { value: 2, text: "ICICI Direct" },
        // { value: 3, text: "Sharekhan" },
        { value: 5, text: "PortfolioSmith Format" },
        { value: 4, text: "Zerodha Tradebook" },
      ],
      brokerType: {
        InternalUser: 1,
        AnandRathiUser: 2,
        AnandRathiUserGuest: 3,
        StandardChartered: 5,
      },
      csv_file: null,
      stocksymbol: "",
      res: null,
      fileUploadBtnTxt: "Import Holdings",
      showdeletefilebtn: false,
      transactionBtnText: "Choose File",
      recommFileBtnTxt: "Upload Recommendations",
      modelFileBtnTxt: "Upload Model Portfolio",
      showImportTransactions: false,
      showUserModal: false,
      showShortSellError: false,
      shortSellErrorMessage: "",
      showSymbolError: false,
      symbolErrorMessage: "",
      symbolErrorSlNo: [],
      userPortfolioFiles: new FormData(),
      loaded: false,
      isLoading: false,
      fullPage: true,
      admin: false,
      sample: "sample_csv_files/sample_upload_file.csv",
      client: "",
      brokerOrModelForRecomm: "No Recommendation",
      brokerOrModelForPortfolio: "Model Portfolio",
      selectedModelPortfolio: 0,
      selectedRecomm: 0,
      date: "date",
      buyPrice: null,
      holdingsJson: [],
      instrumentsJson: [],
      holdingsJsonCount: null,
      brokerPortfolioData: null,
      recommData: null,
      reco: [{ id: 0, name: "No Recommendation" }],
      portfo: [{ id: 0, name: "Model Portfolio" }],
      selectedPortfolioId: 0,
      selectedRecommId: 0,
      validTable: false,
      validRow: false,
      cash: 0,
      suggestions: [],
      sugCurIndex: 0,
      doAutoSuggest: false,
      symIndex: "",
      showSubmitBtn: false,
      msUrl:
        "https://marketsmithindia.com/gateway/simple-api/ms-india/instr/",
      msAuth:
        "ms-auth=3990+MarketSmithINDUID-Web0000000000+MarketSmithINDUID-Web0000000000+3+190910230055+2134291654",
      maxDate: moment().utcOffset("+05:30").add(-1, "d").format("YYYY-MM-DD"),
      minDate: "1900-09-05",
      sessionIdleErrorMsg: "Session is expired. Please login again",
      transactionData: {
        BestExclusions: null,
        WorstExclusions: null,
        BestWinners: null,
        WorstLosers: null,
      },

      allowShortSell: 0,
      brokerToken: localStorage.getItem("brokerToken"),
      addNewmodalShow: false,
      newStock: {
        symbol: "",
        quantity: "",
        buyDate: "",
        buyPrice: "",
        tradeType: "Buy",
      },
      showGenerateReportButton: false,
      isBrokerGuest: false,
      arClientCode: "",
      isCKYCDone: true,
      isPremiumUser: false,
      showLegalAgreement: false,
      legalAgreementContent: "",
      isLoggedin: false,
      legalAgreementId: 0,
      reEvaluatePortfolioData: null,
      lastHoldingsData: null,
      saveUpdateData: false,
      didBrokerManualImport: true,
      isMSIUser: false,
      selectedMSIPortfolioId: null,
      myPortfolioList: [],
      maxDate: moment().add(-1, "d").format("YYYY-MM-DD"),
      minDate: "1994-01-01",
      startDate: this.maxDate,
      endDate: this.maxDate,
      ismyportfolio: false,
      username: "",
      brokerMaualTransaction: [],
      userModalCanceled: false,
      isXLXS: false,
      showEsign: false,
      legalAgreementContentEsign: "",
      esignRecord: null,
      isEsignActive: false,
    };
  },

  beforeCreate() {
    /* if (
      localStorage.getItem("access_token") == null &&
      this.$session.get("access_token") == ""
    ) {
      this.$router.push({
        name: "Logout"
      });
    } */
  },

  computed: {
    ...mapGetters("addholdings", {
      portfolio: "portfolio",
      alphaScopeData: "alphaScopeData",
    }),

    iconPlus() {
      return faPlus;
    },
    iconTrash() {
      return faTrash;
    },
    isReportAvailable() {
      if (this.alphaScopeData) return true;
      else return false;
    },
    userData() {
      //if broker user,generate report if payment done on redirecting to this page
      if (
        this.$store.state.authentication.user.userType ==
        this.brokerType.AnandRathiUserGuest
      ) {
        this.isBrokerGuest = true;
      }

      if (
        this.$store.state.authentication.user.isBrokerUser &&
        !this.isBrokerGuest &&
        localStorage.getItem("postPaymentReportGenerate") == "true"
      ) {
        this.getUserCurrentHoldings(false);
      }
      return this.$store.state.authentication.user;
    },
    userSubscription() {
      return this.$store.state.home.subscription;
    },
  },

  created() {
    if (localStorage.getItem("isMSIUser") === "true") {
      this.isMSIUser = true;
      this.getActiveMSIPortfolioList();
      this.selectedMSIPortfolioId =
        localStorage.getItem("selectedPortfolioId") == ""
          ? null
          : localStorage.getItem("selectedPortfolioId");
      this.brokers.push({
        value: 6,
        text: "My Portfolio from MarketSmith India",
      });
      if (this.selectedMSIPortfolioId != null) {
        this.ismyportfolio = true;
        this.selectedBroker = 6;
        this.showImportTransactions = true;
        this.startDate = this.minDate;
        this.endDate = this.maxDate;
      }
    } else {
      this.checkCkycStatus();
      this.getActiveLegalAgreement("PSI", localStorage.getItem("uid"));

      if (!this.showLegalAgreement) {
        this.checkEsignStatus();
      }
    }
    if (this.$route.params.pastPortfolioData) {
      this.autoPopulateDashboardData();
    } else {
      localStorage.removeItem("reEvaluatePortfolioData");
    }
    if (localStorage.getItem("ShowLastHoldingdata")) {
      this.getLastUserReport();
    }
    this.client = this.userData.name;
    this.didBrokerManualImport = this.userData.isBrokerAdminUser ? true : false;
    window.scrollTo(0, 0);
  },

  mounted() {
    // Mounted Methods should comes here

    if (
      !this.userData.isBrokerUser ||
      this.userData.userType == this.brokerType.AnandRathiUserGuest
    ) {
      setInputFilter(this.$refs.uintTextBox, function (value) {
        return /^\d*$/.test(value);
      });
    }

    if (localStorage.getItem("is_admin") == "true") {
      this.admin = true;
    } else {
      this.admin = false;
    }

    let portfolioJson = JSON.parse(localStorage.getItem("portfolios"));
    this.brokerPortfolioData = portfolioJson;
    for (var i in this.brokerPortfolioData)
      this.portfo.push(this.brokerPortfolioData[i]);

    let recommJson = JSON.parse(localStorage.getItem("recs"));
    this.recommData = recommJson;
    for (var i in this.recommData) this.reco.push(this.recommData[i]);

    if (
      this.portfolio &&
      JSON.parse(this.portfolio.HoldingsData) &&
      JSON.parse(this.portfolio.HoldingsData.length > 0)
    ) {
      this.holdingsJson = JSON.parse(this.portfolio.HoldingsData);
      this.client = this.portfolio.client;
      this.selectedRecomm = this.portfolio.SelectedRecomm;
      this.selectedRecommId = this.portfolio.SelectedRecomm;
      this.selectedPortfolioId = this.portfolio.SelectedModelPortfolio;
      this.selectedModelPortfolio = this.portfolio.SelectedModelPortfolio;
      this.cash = this.portfolio.Cash;
      this.brokerOrModelForRecomm = this.portfolio.BrokerOrModelForRecomm;
      this.brokerOrModelForPortfolio = this.portfolio.BrokerOrModelForPortfolio;
    }

    // For Edit
    // if (this.$route.path === "/ImportHoldings/Edit") {
    // if (
    //   JSON.parse(localStorage.getItem("HoldingsData")) &&
    //   JSON.parse(localStorage.getItem("HoldingsData").length > 0)
    // ) {
    //   this.holdingsJson = JSON.parse(localStorage.getItem("HoldingsData"));
    //   this.client = localStorage.getItem("client");
    //   this.selectedRecomm = localStorage.getItem("SelectedRecomm");
    //   this.selectedRecommId = localStorage.getItem("SelectedRecomm");
    //   this.selectedPortfolioId = localStorage.getItem("SelectedModelPortfolio");
    //   this.selectedModelPortfolio = localStorage.getItem(
    //     "SelectedModelPortfolio"
    //   );
    //   this.cash = localStorage.getItem("Cash");
    // }
    // }

    if (this.$route.query.clear === "true") {
      this.holdingsJson = [];
    }

    this.validateHoldings();
    this.showGenerateReportButton = false;
    if (
      localStorage.preLoginHoldingsData &&
      localStorage.preLoginHoldingsData !== undefined
    ) {
      this.holdingsJson = JSON.parse(getJWTFromStorage("preLoginHoldingsData"));

      this.holdingsJsonCount = this.holdingsJson.length;
      this.validateHoldings(true);
      this.selectedBroker = 5;
      this.showGenerateReportButton = true;
      //this.$refs.importTransactions.value = "";
    }

    this.$nextTick(() => applyDatepickerToggleAriaLabels(this.$el));
  },

  updated() {
    this.$nextTick(() => applyDatepickerToggleAriaLabels(this.$el));
  },

  validations: {
    csv_file: {
      required,
    },
  },

  watch: {
    "$route.query.clear"(val) {
      if (val === "true") {
        this.holdingsJson = [];
      }
    },
  },

  methods: {
    ...mapActions("addholdings", {
      setAlphaScopeData: "setAlphaScopeData",
      setEnableReport: "setEnableReport",
      setPortfolio: "setPortfolio",
      setTransactionData: "setTransactionData",
      setGeneratedReportType: "setGeneratedReportType",
      generateReport: GENERATE_REPORT,
      standardCharteredReport: STANDARD_CHARTEREDDATA_GENERATE_REPORT,
      psilogin: PSI_LOGIN,
      autoSuggestSymbols: AUTO_SUGGEST_SYMBOLS,
      getSymbolPrice: GET_SYMBOL_PRICE,
      getInstrumentId: GET_INSTRUMENT_ID,
      getBrokerUserHoldings: GET_BROKER_USER_HOLDINGS,
      getBrokerAdminUserHoldings: GET_BROKER_ADMIN_USER_HOLDINGS,
      updateSubscription: UPDATE_SUBSCRIPTION,
      postPdfDownloadSuccess: POST_PDF_DOWNLOAD_SUCCESS,
      updatePostPdfDownload: UPDATE_POST_PDF_DOWNLOAD_SUCCESS,
      getActiveMSIPortfolio: GET_ACTIVE_MSI_PORTFOLIO,
      getMStransactionHistory: GET_MS_TRANSACTION_HISTORY,
      validateHolidaDate: VALIDATE_HOLIDAY_DATE,
    }),
    ...mapActions("portfolioreport", {
      setTab: "setTab",
    }),

    ...mapActions({
      getusersubscription: GET_USER_SUBSCRIPTION,
    }),

    ...mapActions({
      userlogout: USER_LOGOUT,
      getBrokerToken: GET_USER_BROKER_TOKEN,
      getBrokerAdminToken: GET_BROKER_ADMIN_TOKEN,
      isRegisteredBrokerUserCall: CHECK_REGISTERED_BROKER_USER,
      checkuserckyc: CHECK_USER_CKYC,
      getlegalagreement: GET_LEGAL_AGREEMENT,
      savelegalagreement: SAVE_LEGAL_AGREEMENT,
      getlastuserreport: GET_USER_LAST_REPORT,
    }),

    autoPopulateDashboardData() {
      let autoPopulatedData = JSON.parse(JSON.stringify(this.$route.params));
      if (
        autoPopulatedData.pastPortfolioData != null ||
        autoPopulatedData.pastPortfolioData != undefined
      ) {
        this.reEvaluatePortfolioData = JSON.parse(
          autoPopulatedData.pastPortfolioData
        );
        localStorage.setItem(
          "reEvaluatePortfolioData",
          autoPopulatedData.pastPortfolioData
        );
        this.saveUpdateData = true;
        this.parseCSV(this.reEvaluatePortfolioData.csv);
      } else if (localStorage.getItem("reEvaluatePortfolioData")) {
        this.reEvaluatePortfolioData = JSON.parse(
          localStorage.getItem("reEvaluatePortfolioData")
        );
        this.saveUpdateData = true;
        this.parseCSV(this.reEvaluatePortfolioData.csv);
      }
    },

    async getLastUserReport() {
      await this.getlastuserreport().then((data) => {
        if (data != null) {
          this.selectedBroker = 5;
          this.saveUpdateData = true;
          this.lastHoldingsData = createCSV(data);
          this.parseCSV(this.lastHoldingsData.csv);
        }
      });
    },

    async fetchusersubscription() {
      await this.getusersubscription();
    },

    async checkCkycStatus() {
      await this.getusersubscription().then(async (subsdata) => {
        const email = localStorage.getItem("uemail");

        if (subsdata != null) {
          this.isPremiumUser = subsdata.remainingAccess > 0 ? true : false;
        }
        await this.checkCkyc(email);
      });
    },

    async getActiveLegalAgreement(productCode, userId) {
      var self = this;
      var payload = {
        userId: userId,
        productCode: productCode,
      };
      await this.getlegalagreement(payload).then((result) => {
        if (result != null) {
          self.showLegalAgreement = !result.isUserAccepted;
          self.legalAgreementContent = result.description;
          self.legalAgreementId = result.id;
        }
      });
    },

    async saveLegalAgreement() {
      var self = this;
      var payload = {
        userId: localStorage.getItem("uid"),
        legalAgreementId: self.legalAgreementId,
        isAccepted: 1,
      };
      await this.savelegalagreement(payload).then((result) => {
        if (result != null) {
        }
      });
    },

    async checkCkyc(email) {
      let params = {
        user_email: email,
      };
      await this.checkuserckyc(params).then((data) => {
        this.isCKYCDone = data.success;
      });
    },

    async getActiveMSIPortfolioList() {
      var self = this;
      let params = {
        memberId: localStorage.getItem("memberId"),
        msAuth: localStorage.getItem("msauth"),
      };
      await this.getActiveMSIPortfolio(params).then((response) => {
        if (!response.data && response.data.status != 200) {
          //this.$toastr.e('Upload failed. Please check your CSV file and then try again.');
          this.$toastr.e("Unable to retrieve User Portfolio list.");
        } else {
          response.data.forEach(function (obj, index) {
            self.myPortfolioList.push({
              value: obj.portfolioId,
              text: obj.portfolioName,
            });
          });
          self.selectedBroker = self.ismyportfolio == true ? 6 : 5;
          if (self.selectedportfoliolistid) {
            self.startDate = self.minDate;
            self.endDate = self.maxDate;
            self.selectedPortfolio = self.selectedportfoliolistid;
          }
        }
      });
    },

    async getMSIselectedPortfolioTransactionHistory() {
      // this.showSubmitBtn = true;
      var self = this;
      const start = this.startDate == undefined ? "" : this.startDate;
      const end = this.endDate == undefined ? "" : this.endDate;
      let params = {
        memberId: localStorage.getItem("memberId"),
        startDate: start,
        endDate: end,
        portfolioId: this.selectedMSIPortfolioId,
        msAuth: localStorage.getItem("msauth"),
      };
      await this.getMStransactionHistory(params).then((response) => {
        if (!response.data && response.status != 200) {
          //this.$toastr.e('Upload failed. Please check your CSV file and then try again.');
          this.$toastr.e("Unable to retrieve User Portfolio list.");
        } else if (response.data.userTransactionModel.length > 0) {
          var pData = [];
          pData.push(["Symbol", "Quantity", "BuyDate", "BuyPrice", "Type"]);
          response.data.userTransactionModel.forEach(function (obj, index) {
            pData.push([
              obj.symbol,
              obj.qty,
              obj.tranDate,
              obj.price,
              obj.tranType,
            ]);
          });

          this.parseCSV(pData);
          // this.processTransaction_msiMyPortfolio(pData);
        } else {
          this.$toastr.e(
            "There are no transaction data for the selected portfolio"
          );
        }
      });
    },

    dateDMYtoYMD(date) {
      const raw = (date ?? "")
        .toString()
        .trim()
        .replace(/^\uFEFF/, "")
        .replace(/^"|"$/g, "");
      const parsed = moment(
        raw,
        [
          "DD-MM-YYYY",
          "DD/MM/YYYY",
          "YYYY-MM-DD",
          "YYYY/MM/DD",
          "DD-MMM-YYYY",
          "DD MMM YYYY",
          "YYYY-MM-DD HH:mm:ss",
          "DD-MM-YYYY HH:mm:ss",
          "DD/MM/YYYY HH:mm:ss",
        ],
        true
      );
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
    },
    parseBuyPrice(value) {
      return _parseBuyPrice(value);
    },
    openShortSellError(errorMessage) {
      this.shortSellErrorMessage = errorMessage;
      this.showShortSellError = true;
    },
    openSymbolError(slNo) {
      this.symbolErrorMessage =
        "Only active NSE/BSE symbols can be updated. If a stock’s symbol was recently changed, our system may take up to 2 days to reflect the update. Please review or delete incorrect symbols accordingly, or click Continue to generate the report by skipping those symbols.";
      this.showSymbolError = true;
      this.symbolErrorSlNo = slNo;
    },
    validateHoldings(show = false) {
      var obj = this.holdingsJson;
      var buyDate = [];
      if (this.holdingsJson.length == 0) {
        this.validTable = false;
        this.validRow = true;
        return true;
      }

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var val = obj[key];
          let validateSymbol = !this.validateSymbol(
            val["Symbol"],
            key,
            show,
            show
          );

          let validatePrice = !this.validatePrice(
            val["BuyPrice"],
            key,
            show,
            show
          );

          let validateQuantity = !this.validateQuantity(
            val["Quantity"],
            key,
            show,
            show
          );
          let validDate = val["BuyDate"] != null && val["BuyDate"] != "";
          if (show && !validDate) {
            var priceError = this.$toastr.Add({
              name: "price-error", // this is give you ability to use removeByName method
              msg: "Purchase Date & Buy Price is Mandatory", // Toast Message
              type: "error", // Toast type,
              position: "toast-top-full-width",
              clickClose: true, // Click Close Disable
              timeout: 0,
              showCloseButton: true,
            });
          }
          let weekendDate = this.is_weekend(val["BuyDate"]);
          if (weekendDate) {
            let message = val["SlNo"];
            var priceError = this.$toastr.Add({
              name: "price-error", // this is give you ability to use removeByName method
              msg: "SlNo." + message + " contains weekend Date.", // Toast Message
              type: "error", // Toast type,
              position: "toast-top-full-width",
              clickClose: true, // Click Close Disable
              timeout: 0,
              showCloseButton: true,
            });
          } else {
            buyDate.push(val["BuyDate"]);
          }
          if (
            !validateSymbol ||
            !validatePrice ||
            !validateQuantity ||
            !validDate ||
            weekendDate
          ) {
            this.validRow = false;
            this.validTable = false;
            return false;
          }
        }
      }

      if (buyDate.length > 0) {
        let dateString = buyDate.join(",");
        let isValidDate = this.getholidayDate(dateString, obj);
        if (isValidDate === false) {
          return false;
        }
      }
      this.validRow = true;
      this.validTable = true;
      return true;
    },

    async getholidayDate(dateString, obj) {
      try {
        const holidayDates = await this.validateHolidaDate(dateString);

        if (holidayDates && holidayDates.data.response.length) {
          const holidayDateList = holidayDates.data.response.map(
            (item) => item.HolidayDate
          );

          const holidayRows = obj
            .filter((item) => holidayDateList.includes(item.BuyDate))
            .map((item) => item.SlNo);

          if (holidayRows.length) {
            this.$toastr.Add({
              name: "price-error",
              msg:
                "Following rows contain market holiday dates: " +
                holidayRows.join(", "),
              type: "error",
              position: "toast-top-full-width",
              clickClose: true,
              timeout: 0,
              showCloseButton: true,
            });
            this.validRow = false;
            this.validTable = false;
            return false;
          }
        }
      } catch (err) {
        console.error("Error checking holidays", err);
      }
    },

    validateSymbol(symbol, index, show = true, isFile = false) {
      this.stocksymbol = symbol.length;
      if (symbol !== "" && symbol !== null) {
        this.$toastr.removeByName("symbol-error");
        if (
          symbol.length > 1 &&
          this.doAutoSuggest == true &&
          this.symIndex == index
        ) {
          this.sugCurIndex = index;
          this.autoSuggest(symbol);
        } else {
          this.suggestions = [];
        }
        return false;
      } else {
        this.holdingsJson[index]["BuyPrice"] = "";
        this.holdingsJson[index]["BuyDate"] = "";
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var symbolError = this.$toastr.Add({
            name: "symbol-error", // this is give you ability to use removeByName method
            msg: "Sl.No " + (parseInt(index) + 1) + " Symbol is mandatory.", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width", //toast-top-full-width
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }

        return true;
      }
    },
    validateSymbolResponsive(symbol, show = true, isFile = false) {
      if (symbol !== "" && symbol !== null) {
        this.$toastr.removeByName("symbol-error");
        if (symbol.length > 0 && this.doAutoSuggest == true) {
          this.autoSuggest(symbol);
        } else {
          this.suggestions = [];
        }
        return false;
      } else {
        this.newStock.buyPrice = "";
        this.newStock.buyDate = "";
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var symbolError = this.$toastr.Add({
            name: "symbol-error", // this is give you ability to use removeByName method
            msg: "Symbol is mandatory.", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width", //toast-top-full-width
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }

        return true;
      }
    },

    changeCash(e) {
      if (e.target.value.trim() == "") {
        this.cash = 0;
      } else {
        this.cash = e.target.value;
      }
    },

    async autoSuggest(symbol) {
      await this.autoSuggestSymbols(
        this.msUrl +
          "srch.json?text=" +
          symbol +
          "&lang=en&listID=-1&ver=2&" +
          this.msAuth
      ).then((response) => {
        if (!response.data && response.data.status != 200) {
          this.suggestions = [];
          this.$toastr.e(
            "Upload failed. Please check your CSV file and then try again."
          );
        } else {
          this.suggestions = response.data.response.results;
          return response;
        }
      });
    },

    updateSuggestion(index, resultsArr, key) {
      this.holdingsJson[index][key] = resultsArr.symbol;
      this.instrumentsJson[resultsArr.symbol] = resultsArr.instrumentId;
      this.suggestions = [];
      if (this.holdingsJson[index]["BuyPrice"] != "") {
        this.updatePriceByDate(index, this.holdingsJson[index]["BuyDate"]);
      }
      this.doAutoSuggest = false;
    },

    updateSuggestionResponsive(resultsArr, key) {
      this.newStock.instrumentId = resultsArr.instrumentId;
      this.newStock.symbol = resultsArr.symbol;
      this.suggestions = [];
      if (this.newStock.buyPrice != "") {
        this.updatePriceByDateResponsive(this.newStock.buyPrice);
      }
      this.doAutoSuggest = false;
    },

    validateQuantity(quantity, key, show = true, isFile = false) {
      var pattern = new RegExp("^[1-9]\\d*$");
      if (
        quantity !== "" &&
        quantity !== null &&
        quantity % 1 === 0 &&
        quantity !== "0" &&
        typeof parseInt(quantity) === "number" &&
        parseInt(quantity) != 0
      ) {
        this.$toastr.removeByName("quantity-error");
        return false;
      } else {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var quantityError = this.$toastr.Add({
            name: "quantity-error", // this is give you ability to use removeByName method
            msg:
              "Sl.No " +
              (parseInt(key) + 1) +
              "<br>Quantity is mandatory <br> - Must be a positive integer number <br> - Decimals not Allowed <br> - Quantity should not be Zero", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }
        return true;
      }
    },

    validateQuantityResponsive(quantity, show = true, isFile = false) {
      var pattern = new RegExp("^[1-9]\\d*$");
      if (
        quantity !== "" &&
        quantity !== null &&
        quantity % 1 === 0 &&
        quantity !== "0" &&
        typeof parseInt(quantity) === "number"
      ) {
        this.$toastr.removeByName("quantity-error");
        return false;
      } else {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var quantityError = this.$toastr.Add({
            name: "quantity-error", // this is give you ability to use removeByName method
            msg: "Quantity is mandatory <br> - Must be a positive integer number <br> - Decimals not Allowed <br> - Quantity should not be Zero", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }
        return true;
      }
    },

    validatePrice(price, key, show = true, isFile = false) {
      //price = parseFloat(price)
      if (price === "" || price === null) {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Sl.No " + (parseInt(key) + 1) + " Buy Price is Mandatory", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }
        return true;
      } else if (!isNaN(parseFloat(price)) && parseFloat(price) >= 0) {
        localStorage.setItem(
          "preLoginHoldingsData",
          JSON.stringify(this.holdingsJson)
        );
        this.$toastr.removeByName("price-error");
        return false;
      } else {
        if (show) {
          this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price cannot be less than 0, please input the Buy Price of the stock", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }
        return true;
      }
    },
    validatePriceResponsive(price, show = true, isFile = false) {
      //price = parseFloat(price)
      if (price === "" || price === null) {
        if (show) {
          if (!isFile) this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price is Mandatory", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }
        return true;
      } else if (price >= 0 && typeof parseFloat(price) === "number") {
        this.$toastr.removeByName("price-error");
        return false;
      } else {
        if (show) {
          this.$toastr.removeByType("error");
          var priceError = this.$toastr.Add({
            name: "price-error", // this is give you ability to use removeByName method
            msg: "Buy Price cannot be less than 0, please input the Buy Price of the stock", // Toast Message
            type: "error", // Toast type,
            position: "toast-top-full-width",
            clickClose: true, // Click Close Disable
            timeout: 0,
            showCloseButton: true,
          });
        }
        return true;
      }
    },

    reset() {
      /*  if (!isTokenValid()) {
         this.logout(this.sessionIdleErrorMsg);
         return;
       } */
      localStorage.removeItem("preLoginHoldingsData");
      localStorage.removeItem("HoldingsData");
      localStorage.removeItem("ShowLastHoldingdata");
      localStorage.setItem("arClientName", this.userData.name);
      this.didBrokerManualImport = true;
      this.brokerMaualTransaction = [];
      this.cash = 0;
      this.holdingsJson = [];
      this.suggestions = [];
      this.isXLXS = false;
      this.fileUploadBtnTxt = "Import Holdings";
      const files = this.$refs.importHoldings.files;
      this.$refs.importHoldings.value = "";

      this.$toastr.removeByName("symbol-error");
      this.$toastr.removeByName("quantity-error");
      this.$toastr.removeByName("price-error");

      this.holdingsJson.forEach(function (obj, index) {
        $(`#${index + 1}Symbol`).removeClass("errorCellClass");
        $(`#${index + 1}BuyDate`).removeClass("errorCellClass");
      });

      this.setAlphaScopeData(null);
      this.setPortfolio(null);

      this.validateHoldings();
      this.showGenerateReportButton = false;
      window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    },

    async saveImportData() {
      const reportObj = {
        reportUrl: "",
        fileName: "",
        isPremium: this.isPremiumUser ? "1" : "0",
        inputData: JSON.stringify(this.holdingsJson),
        outputData: null,
        comments: "",
      };
      await this.saveData(reportObj);
    },

    async saveData(reportObj) {
      await this.postPdfDownloadSuccess(reportObj).then((response) => {
        if (response.data.response.report != null) {
          this.saveUpdateData = true;
          localStorage.setItem("ShowLastHoldingdata", true);
          this.$toastr.Add({
            name: "save-import-success",
            msg: "Successfully Saved",
            type: "success",
            position: "toast-top-full-width",
            clickClose: true,
            timeout: 5000,
            showCloseButton: true,
          });
        }
      });
    },

    async updateImportData() {
      if (this.reEvaluatePortfolioData != null) {
        const reportObj = {
          id: this.reEvaluatePortfolioData.id,
          reportUrl: "",
          fileName: "",
          isPremium: this.reEvaluatePortfolioData.isPremium,
          inputData: JSON.stringify(this.holdingsJson),
          outputData: null,
          comments: "",
        };
        this.updateData(reportObj);
      } else if (this.lastHoldingsData != null) {
        const reportObj = {
          id: this.lastHoldingsData.id,
          reportUrl: "",
          fileName: "",
          isPremium: this.lastHoldingsData.isPremium,
          inputData: JSON.stringify(this.holdingsJson),
          outputData: null,
          comments: "",
        };
        this.updateData(reportObj);
      }
    },

    async updateData(reportObj) {
       this.$toastr.Add({
            name: "save-import-success",
            msg: "Successfully updated",
            type: "success",
            position: "toast-top-full-width",
            clickClose: true,
            timeout: 5000,
            showCloseButton: true,
          });
      await this.updatePostPdfDownloadSuccess(reportObj).then((response) => {});
    },

    changePortfolio(event) {
      this.selectedPortfolioId = event;
      for (var i in this.portfo)
        if (this.portfo[i].id === event)
          this.brokerOrModelForPortfolio = this.portfo[i].name;
    },

    changeRecomm(event) {
      this.selectedRecommId = event;
      for (var i in this.reco)
        if (this.reco[i].id === event)
          this.brokerOrModelForRecomm = this.reco[i].name;
    },

    changeTradeType(index, event, key) {
      if (
        this.holdingsJson[index][key] != "" &&
        this.holdingsJson[index][key] != undefined &&
        this.holdingsJson[index][key] != null
      ) {
        if (event.target.value == "1") {
          if (
            key == "Quantity" &&
            this.holdingsJson[index][key].includes("-")
          ) {
            this.holdingsJson[index][key] = "";
            this.holdingsJson[index][key] = `${event.target.value}`;
          } else {
            this.holdingsJson[index][
              key
            ] = `-${this.holdingsJson[index]["Quantity"]}`;
          }
        } else if (event.target.value == "2") {
          this.holdingsJson[index][key] = "";
        } else {
          this.holdingsJson[index][key] = this.holdingsJson[index][key].replace(
            "-",
            ""
          );
        }
      } else {
        this.$toastr.e(
          "Please add a valid Quantity before changing the Trade Type"
        );
        return false;
      }
    },

    changeTradeTypeResponsive(event) {
      if (
        this.newStock.quantity != "" &&
        this.newStock.quantity != undefined &&
        this.newStock.quantity != null
      ) {
        if (event.target.value == "1") {
          this.newStock.quantity = `-${this.newStock.quantity}`;
        } else {
          this.newStock.quantity = this.newStock.quantity.replace("-", "");
        }
      } else {
        this.$toastr.e(
          "Please add a valid Quantity before changing the Trade Type"
        );
        return false;
      }
    },

    logout(msg) {
      this.$router.push({ name: "Logout" });
      this.$toastr.e(msg);
    },

    downloadSample() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      document.querySelector("#alpha-btn").click();
    },

    changebroker(e) {
      this.selectedBroker = e;
      if ((e = 6)) {
        this.startDate = this.minDate;
        this.endDate = this.maxDate;
      }
    },

    downloadTransaction(type) {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      document.querySelector("#" + type).click();
    },

    downloadSampleReport() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      this.$refs.downloadSampleReport.click();
      // document.querySelector("#downloadSampleReport").click();
    },

    addNewRow() {
      //  if(this.holdingsJson.length===100){
      //   this.$toastr.e("Maximum numbers of rows allowed per portfolio is 100");
      //   return;
      // }

      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      if (this.validateHoldings() === true) {
        this.holdingsJson.push({
          Symbol: "",
          Quantity: "",
          BuyDate: "",
          BuyPrice: "",
          SlNo: this.holdingsJson.length + 1,
        });
      }
      this.validTable = false;
      this.validRow = false;
    },

    updateJson: debounce(function (index, event, key) {
      if (
        key == "Quantity" &&
        this.holdingsJson[index][key].toString().includes("-")
      ) {
        this.holdingsJson[index][key] = "";
        this.holdingsJson[index][key] = `${event.target.value}`;
      } else {
        this.holdingsJson[index][key] = event.target.value;
      }
      if (key != "Symbol") {
        this.suggestions = [];
        this.doAutoSuggest = false;
        this.symIndex = "";
      } else {
        this.doAutoSuggest = true;
        this.symIndex = index;
        $(`#${index + 1}Symbol`).removeClass("errorCellClass");
      }
      if (key == "BuyDate") {
        $(`#${index + 1}BuyDate`).removeClass("errorCellClass");
      }
      let validateSymbol = !this.validateSymbol(
        this.holdingsJson[index]["Symbol"],
        index,
        false
      );
      let validatePrice = !this.validatePrice(
        this.holdingsJson[index]["BuyPrice"],
        index,
        false
      );
      let validateQuantity = !this.validateQuantity(
        this.holdingsJson[index]["Quantity"],
        index,
        false
      );
      let validDate = this.holdingsJson[index]["BuyDate"] != "";

      if (key == "Symbol") {
        this.validRow =
          !this.validateSymbol(this.holdingsJson[index][key], index) &&
          validatePrice &&
          validateQuantity &&
          validDate;
        // this.validTable =
        //   !this.validateSymbol(this.holdingsJson[index][key], index) &&
        //   validatePrice &&
        //   validateQuantity &&
        //   validDate;
      }
      if (key == "BuyPrice") {
        this.validRow =
          !this.validatePrice(this.holdingsJson[index][key], index) &&
          validateSymbol &&
          validateQuantity &&
          validDate;
        // this.validTable =
        //   !this.validatePrice(this.holdingsJson[index][key], index) &&
        //   validateSymbol &&
        //   validateQuantity &&
        //   validDate;
      }
      if (key == "Quantity") {
        this.validRow =
          !this.validateQuantity(this.holdingsJson[index][key], index) &&
          validateSymbol &&
          validatePrice &&
          validDate;
        // this.validTable =
        //   !this.validateQuantity(this.holdingsJson[index][key], index) &&
        //   validateSymbol &&
        //   validatePrice &&
        //   validDate;
      }
      this.validTable = this.validateHoldings();
    }, 500),
    updateJsonResponsive: debounce(function (event, key) {
      if (key == "Quantity") {
        $(`#PopupQuantity`).removeClass("errorCellClass");
        if (this.newStock.quantity.toString().includes("-")) {
          this.newStock.quantity = "";
          this.newStock.quantity = `-${event.target.value}`;
        } else {
          this.newStock.quantity = event.target.value;
        }
      }
      if (key != "Symbol") {
        this.suggestions = [];
        this.doAutoSuggest = false;
      } else {
        this.newStock.symbol = event.target.value;
        this.doAutoSuggest = true;
        $(`#PopupSymbol`).removeClass("errorCellClass");
      }
      if (key == "BuyDate") {
        $(`#PopupBuyDate`).removeClass("errorCellClass");
      }
      let validateSymbol = !this.validateSymbolResponsive(this.newStock.symbol);
      let validatePrice = !this.validatePriceResponsive(this.newStock.buyPrice);
      let validateQuantity = !this.validateQuantityResponsive(
        this.newStock.quantity
      );
      let validDate = this.newStock.buyDate != "";

      if (key == "Symbol") {
        this.validRow =
          !this.validateSymbolResponsive(this.newStock.symbol) &&
          validatePrice &&
          validateQuantity &&
          validDate;
        this.$toastr.removeByName("quantity-error");
        // this.validTable =
        //   !this.validateSymbol(this.holdingsJson[index][key], index) &&
        //   validatePrice &&
        //   validateQuantity &&
        //   validDate;
      }
      if (key == "BuyPrice") {
        this.validRow =
          !this.validatePriceResponsive(this.newStock.buyPrice) &&
          validateSymbol &&
          validateQuantity &&
          validDate;
        // this.validTable =
        //   !this.validatePrice(this.holdingsJson[index][key], index) &&
        //   validateSymbol &&
        //   validateQuantity &&
        //   validDate;
      }
      if (key == "Quantity") {
        this.validRow =
          !this.validateQuantityResponsive(this.newStock.quantity) &&
          validateSymbol &&
          validatePrice &&
          validDate;
        // this.validTable =
        //   !this.validateQuantity(this.holdingsJson[index][key], index) &&
        //   validateSymbol &&
        //   validatePrice &&
        //   validDate;
      }
    }, 500),

    updateBuyDate(index, value) {
      let validateSymbol = !this.validateSymbol(
        this.holdingsJson[index]["Symbol"],
        index,
        false
      );
      let validatePrice = !this.validatePrice(
        this.holdingsJson[index]["BuyPrice"],
        index,
        false
      );
      let validateQuantity = !this.validateQuantity(
        this.holdingsJson[index]["Quantity"],
        index,
        false
      );

      if (
        moment(moment(value).format("YYYY-MM-DD"), "YYYY-MM-DD", true).isValid()
      ) {
        let val = moment(value).format("YYYY-MM-DD");
        this.holdingsJson[index]["BuyDate"] = val;
        this.updatePriceByDate(index, val);
        $(`#${index + 1}BuyDate`).removeClass("errorCellClass");
        this.validRow =
          true && validateSymbol && validatePrice && validateQuantity;
        this.validTable = this.validateHoldings();
      } else {
        this.$toastr.removeByType("error");
        var priceError = this.$toastr.Add({
          name: "price-error", // this is give you ability to use removeByName method
          msg: "Purchase Date & Buy Price is Mandatory", // Toast Message
          type: "error", // Toast type,
          position: "toast-top-full-width",
          clickClose: true, // Click Close Disable
          timeout: 0,
          showCloseButton: true,
        });
        this.holdingsJson[index]["BuyPrice"] = "";
        this.validRow = false;
        this.validTable = false;
      }
      this.suggestions = [];
      this.doAutoSuggest = false;
    },

    updateBuyDateResponsive(value) {
      if (
        moment(moment(value).format("YYYY-MM-DD"), "YYYY-MM-DD", true).isValid()
      ) {
        let val = moment(value).format("YYYY-MM-DD");
        this.newStock.buyDate = val;
        this.updatePriceByDateResponsive(val);
        $(`#PopupBuyDate`).removeClass("errorCellClass");
      } else {
        this.$toastr.removeByType("error");
        var priceError = this.$toastr.Add({
          name: "price-error", // this is give you ability to use removeByName method
          msg: "Purchase Date & Buy Price is Mandatory", // Toast Message
          type: "error", // Toast type,
          position: "toast-top-full-width",
          clickClose: true, // Click Close Disable
          timeout: 0,
          showCloseButton: true,
        });
        this.newStock.buyPrice = "";
      }
      this.suggestions = [];
      this.doAutoSuggest = false;
    },

    // updatePriceByDate(index, date) {
    //   let instIndex = this.holdingsJson[index]["Symbol"];
    //   if (this.instrumentsJson[instIndex] != undefined) {
    //     let instrumentId = this.instrumentsJson[instIndex];
    //     this.getPriceAPI(index, date, instrumentId);
    //   } else {
    //     if (instIndex != "" && instIndex != null) {
    //       this.getInstId(index, date);
    //     } else {
    //       this.holdingsJson[index]["BuyPrice"] = "";
    //       this.validateHoldings();
    //     }
    //   }
    //   this.suggestions = [];
    // },

    updatePriceByDate(index, date) {

      if (!this.holdingsJson[index]) return;

      let instIndex = this.holdingsJson[index]["Symbol"];

      if (!instIndex) return;

      if (this.instrumentsJson[instIndex] != undefined) {
        let instrumentId = this.instrumentsJson[instIndex];
        this.getPriceAPI(index, date, instrumentId);
      } else {
        this.getInstId(index, date);
      }
    },

    updatePriceByDateResponsive(date) {
      let instrumentId = this.newStock.instrumentId;
      if (instrumentId != undefined) {
        let instrumentId = this.newStock.instrumentId;
        this.getPriceAPIResponsive(date, instrumentId);
      } else {
        this.newStock.buyPrice = "";
      }
      this.suggestions = [];
    },

    async getPriceAPI(index, date, instrumentId) {
      if (instrumentId !== "") {
        date = moment(date, "YYYY-MM-DD")
          .utcOffset("+05:30")
          .format("DD/MM/YYYY");
        await this.getSymbolPrice(
          this.msUrl +
            "getPriceForSymbol.json?instId=" +
            instrumentId +
            "&transDate=" +
            date +
            "&splitAdjust=" +
            "&" +
            this.msAuth
        ).then((response) => {
          if (!response.data && response.data.status != 200) {
            //this.$toastr.e('Upload failed. Please check your CSV file and then try again.');
            this.$toastr.e("Unable to retrieve price, kindly enter manually.");
          } else {
            this.holdingsJson[index]["BuyPrice"] = parseFloat(
              response.data.Price
            ).toFixed(2);
            this.validateHoldings(false);
            return response;
          }
        });
      } else {
        this.holdingsJson[index]["BuyPrice"] = "";
        this.$toastr.e("Unable to retrieve price, kindly enter manually.");
      }
      this.suggestions = [];
    },

    async getPriceAPIResponsive(date, instrumentId) {
      if (instrumentId !== "") {
        date = moment(date, "YYYY-MM-DD")
          .utcOffset("+05:30")
          .format("DD/MM/YYYY");
        await this.getSymbolPrice(
          this.msUrl +
            "getPriceForSymbol.json?instId=" +
            instrumentId +
            "&transDate=" +
            date +
            "&splitAdjust=" +
            "&" +
            this.msAuth
        ).then((response) => {
          if (!response.data && response.data.status != 200) {
            //this.$toastr.e('Upload failed. Please check your CSV file and then try again.');
            this.$toastr.e("Unable to retrieve price, kindly enter manually.");
          } else {
            this.newStock.buyPrice = parseFloat(response.data.Price).toFixed(2);
            this.$toastr.removeByName("price-error");
            return response;
          }
        });
      } else {
        this.newStock.buyPrice = "";
        this.$toastr.e("Unable to retrieve price, kindly enter manually.");
      }
      this.suggestions = [];
    },

    async getInstId(index, date) {
      let curSymbol = this.holdingsJson[index]["Symbol"];
      await this.getInstrumentId(
        this.msUrl +
          "srch.json?text=" +
          curSymbol +
          "&lang=en&listID=-1&ver=2&" +
          this.msAuth
      ).then((response) => {
        let instrumentId = "";
        if (response.data.response.results.length > 0) {
          instrumentId = response.data.response.results[0].instrumentId;
        }
        this.getPriceAPI(index, date, instrumentId);
      });
      this.suggestions = [];
    },

    deleteRow(index) {
      this.holdingsJson.splice(index, 1);
      this.holdingsJson.forEach(function (obj, indexx) {
        obj.SlNo = indexx + 1;
        $(`#${indexx + 1}Symbol`).removeClass("errorCellClass");
        $(`#${indexx + 1}BuyDate`).removeClass("errorCellClass");
      });
      if (this.holdingsJson.length == 0) {
        localStorage.removeItem("preLoginHoldingsData");
      }
      this.validateHoldings();
      if (index == 0) {
        this.showGenerateReportButton = false;
      }
    },

    previewImportHoldingsFiles() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      if (this.$refs.importHoldings.files.length > 0) {
        this.userPortfolioFiles = this.$refs.importHoldings.files;
        if (this.userPortfolioFiles[0].name != null) {
          this.fileUploadBtnTxt = this.userPortfolioFiles[0].name;
          //$('#ShowAlphaScope').removeClass('disabled');
        }
        if (window.FileReader) {
          var results = this.getText(this.userPortfolioFiles[0]);
          $(".newRows").remove();
        } else {
          alert("FileReader are not supported in this browser.");
        }
      }
    },

    previewImportTransaction() {
      /* if (!isTokenValid()) {
        this.logout(this.sessionIdleErrorMsg);
        return;
      } */
      this.transactionfile = this.$refs.importTransactions.files[0];
      if (this.$refs.importTransactions.files[0].name != null) {
        this.transactionBtnText = this.transactionfile.name;
        this.showdeletefilebtn = true;
        this.showSubmitBtn = true;
      }
    },

    deleteselectedfile() {
      this.$refs.importTransactions.value = "";
      this.transactionBtnText = "Choose File";
      this.showdeletefilebtn = false;
      this.showSubmitBtn = false;
    },

    submitTransaction() {
      this.transactionBtnText = "Choose File";
      if (this.$refs.importTransactions.files.length > 0) {
        if (window.FileReader) {
          var reader = new FileReader();
          this.rABS = !reader.readAsBinaryString;
          if (this.userData.isBrokerAdminUser) {
            this.didBrokerManualImport = true;
            localStorage.setItem("arClientCode", this.userData.clientCode);
            localStorage.setItem("arClientName", this.userData.name);
          }
          if (
            this.transactionfile.name.includes(".csv") ||
            this.transactionfile.name.includes(".CSV")
          ) {
            reader.readAsText(this.transactionfile);
            reader.onload = this.loadCSVHandler;
          } else if (
            this.transactionfile.name.includes(".xlsx") ||
            this.transactionfile.name.includes(".xls")
          ) {
            if (this.rABS) reader.readAsBinaryString(this.transactionfile);
            else reader.readAsArrayBuffer(this.transactionfile);
            reader.onload = this.loadTransactionHandler;
          } else {
            this.$toastr.e("File type not supported.");
          }

          reader.onerror = this.errorHandler;
        }
      } else {
        alert("FileReader are not supported in this browser.");
      }
    },

    getText(fileToRead) {
      var reader = new FileReader();
      reader.readAsText(fileToRead);
      reader.onload = this.loadHandler;
      reader.onerror = this.errorHandler;
    },

    loadCSVHandler(event) {
      var csv = event.target.result;
      // this.parseCSV(csv);
      this.cancelModal(csv);
      this.$refs.importTransactions.value = "";
    },

    parseCSV(csv) {
      const parseTradeDate = (value) => {
        const raw = (value ?? "")
          .toString()
          .trim()
          .replace(/^\uFEFF/, "")
          .replace(/^"|"$/g, "");

        if (!raw) return "";

        // Zerodha exports can vary across brokers/exports: accept common variants.
        const parsed = moment(
          raw,
          [
            "YYYY-MM-DD",
            "DD/MM/YYYY",
            "DD-MM-YYYY",
            "YYYY/MM/DD",
            "DD-MMM-YYYY",
            "DD MMM YYYY",
            "YYYY-MM-DD HH:mm:ss",
            "YYYY/MM/DD HH:mm:ss",
            "DD/MM/YYYY HH:mm:ss",
            "DD-MM-YYYY HH:mm:ss",
          ],
          true
        );

        if (parsed.isValid()) return parsed.format("YYYY-MM-DD");

        // Fallback (non-strict) for odd-but-parseable values.
        const loose = moment(raw);
        return loose.isValid() ? loose.format("YYYY-MM-DD") : "";
      };

      let columnIndex = {
        Symbol: null,
        Quantity: null,
        BuyDate: null,
        BuyPrice: null,
      };
      var a = [];
      var data = [];
      let startRow = null;

      if (this.selectedBroker === 6) {
        data = csv;
      } else {
        var lines = csv.split("\n");
        lines.forEach((element) => {
          data.push(element.split(","));
        });
        // data.pop();
      }

      // this.cancelModal();
      let formatError = false;
      switch (this.selectedBroker) {
        // case 1:
        //   startRow = 4;
        //   columnIndex.Symbol = 0;
        //   columnIndex.Quantity = 4;
        //   columnIndex.BuyDate = 2;
        //   columnIndex.BuyPrice = 5;
        //   break;
        // case 2:
        //   startRow = 1;
        //  columnIndex.Symbol = 1;
        //   columnIndex.Quantity = 3;
        //   columnIndex.BuyDate = 0;
        //   columnIndex.BuyPrice = 4;
        //   break;
        // case 3:
        //   startRow = 3;
        //   columnIndex.Symbol = 0;
        //   columnIndex.Quantity = 1;
        //   columnIndex.BuyDate = 2;
        //   columnIndex.BuyPrice = 4;
        //   break;
        case 4:
          startRow = 1;
          columnIndex.Symbol = data[0].findIndex((item) =>
            item.toLowerCase().includes("symbol")
          );
          columnIndex.Quantity = data[0].findIndex((item) =>
            item.toLowerCase().includes("quantity")
          );
          columnIndex.BuyDate = data[0].findIndex(
            (item) =>
              item.toLowerCase().includes("trade_date") ||
              item.toLowerCase().includes("date") ||
              item.toLowerCase().includes("buydate")
          );
          columnIndex.BuyPrice = data[0].findIndex(
            (item) =>
              item.toLowerCase().includes("price") ||
              item.toLowerCase().includes("buyprice")
          );
          columnIndex.TradeType = data[0].findIndex(
            (item) =>
              item.toLowerCase().includes("trade_type") ||
              item.toLowerCase().includes("type")
          );
          break;
        case 5:
          startRow = 1;
          columnIndex.Symbol = data[0].findIndex((item) =>
            item.toLowerCase().includes("symbol")
          );
          columnIndex.Quantity = data[0].findIndex((item) =>
            item.toLowerCase().includes("quantity")
          );
          columnIndex.BuyDate = data[0].findIndex(
            (item) =>
              item.toLowerCase().includes("buydate") ||
              item.toLowerCase().includes("date")
          );
          columnIndex.BuyPrice = data[0].findIndex(
            (item) =>
              item.toLowerCase().includes("buyprice") ||
              item.toLowerCase().includes("price")
          );
          columnIndex.TradeType = data[0].findIndex((item) =>
            item.toLowerCase().includes("type")
          );

          // if(data[0][0]=='symbol')
          // {
          //   columnIndex.Symbol = 0;
          //   columnIndex.Quantity = 7;
          //   columnIndex.BuyDate = 2;
          //   columnIndex.BuyPrice = 8;
          //   columnIndex.TradeType = 6;
          // }
          // else if(data[0][0]=='trade_date')
          // {
          //   columnIndex.Symbol = 1;
          //   columnIndex.Quantity = 5;
          //   columnIndex.BuyDate = 0;
          //   columnIndex.BuyPrice = 6;
          //   columnIndex.TradeType = 4;
          // }
          // else if(data[0][0]=='Symbol' && data[0][1]=='Quantity')
          // {
          //   columnIndex.Symbol = 0;
          //   columnIndex.Quantity = 1;
          //   columnIndex.BuyDate = 2;
          //   columnIndex.BuyPrice = 3;
          //   columnIndex.TradeType = 4;
          // }
          //
          break;
        case 6:
          startRow = 1;
          columnIndex.Symbol = data[0].indexOf("Symbol");
          columnIndex.Quantity = data[0].indexOf("Quantity");
          columnIndex.BuyDate = data[0].indexOf("BuyDate");
          columnIndex.BuyPrice = data[0].indexOf("BuyPrice");
          columnIndex.TradeType = data[0].indexOf("Type");
          break;
        default:
      }
      formatError = Object.values(columnIndex).includes(-1);
      if (formatError) {
        this.$toastr.e(
          "The file is different from the expected format. Please see the sample file headers and upload accordingly."
        );
      }
      if (!formatError) {
        for (var i = startRow; i < data.length; i++) {
          const { Symbol, Quantity, BuyDate, BuyPrice, TradeType } =
            columnIndex;
          let p = {
            Symbol: "",
            Quantity: "",
            BuyDate: "",
            BuyPrice: "",
            SlNo: i,
          };
          let str =
            data[i][Symbol] === undefined ? "" : data[i][Symbol].toString();
          p.Symbol = str.trim();
          p.Quantity = this.formatQuantity(data[i], Quantity, TradeType);
          p.BuyDate = parseTradeDate(data[i][BuyDate]);
          p.BuyPrice = this.parseBuyPrice(data[i][BuyPrice]);
          a.push(p);
          if (i == data.length - 2) {
            if (data[data.length - 1].length <= 1) {
              break;
            }
          }
        }
        this.showImportTransactions = false;
        this.holdingsJson = a;
        this.holdingsJsonCount = this.holdingsJson.length;
        this.validateHoldings(false);
        // this.selectedBroker = 5;
        this.showGenerateReportButton = true;

        this.holdingsJson.forEach((row, index) => {
          if (
            row.Symbol &&
            row.BuyDate &&
            (row.BuyPrice === "" || row.BuyPrice === null || row.BuyPrice === undefined)
          ) {
            this.updatePriceByDate(index, row.BuyDate);
          }
        });
      }
    },

    loadTransactionHandler(event) {
      const reader = new FileReader();
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, { type: this.rABS ? "binary" : "array" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_row_object_array(ws, { header: 1 });
      this.isXLXS = true;
      this.cancelModal(data);
      // this.processTransaction(data);
    },

    processTransaction(transactions) {
      // this.cancelModal();
      this.$toastr.removeByName("symbol-error");
      this.$toastr.removeByName("quantity-error");
      this.$toastr.removeByName("price-error");
      this.holdingsJson.forEach(function (obj, index) {
        $(`#${index + 1}Symbol`).removeClass("errorCellClass");
        $(`#${index + 1}BuyDate`).removeClass("errorCellClass");
      });
      let data = transactions.filter(function (el) {
        return Array.isArray(el) && el.length > 0;
      });
      let formattedData = [];
      let a = [];
      let startRow = null;
      let columnIndex = {
        Symbol: null,
        Quantity: null,
        BuyDate: null,
        BuyPrice: null,
      };
      let formatError = false;
      let headerRow = data[0] || [];
      let normalizedHeaders = headerRow.map((h) => h?.toString().toLowerCase());

      const requiredHeaders = ["symbol", "quantity", "date", "price"];
      let missingHeaders = requiredHeaders.filter(
        (h) => !normalizedHeaders.some((header) => header.includes(h))
      );

      let zeroQuantityRows = data.slice(1).filter((row) => {
        let qtyIndex = normalizedHeaders.findIndex((h) =>
          h.includes("quantity")
        );
        return (
          row[qtyIndex] === 0 ||
          row[qtyIndex] === "0" ||
          row[qtyIndex] === undefined ||
          row[qtyIndex] === null ||
          row[qtyIndex] === ""
        );
      });

      if (missingHeaders.length > 0) {
        // Option A: Stop and show error
        this.$toastr.e(
          `The upload file does not carry  header please refer sample file: ${missingHeaders.join(
            ", "
          )}`
        );

        if (zeroQuantityRows.length > 0) {
          this.$toastr.e(
            "Some rows have Quantity as 0 or empty. Please correct them before uploading."
          );
          return;
        }

        // Option B: fallback mapping (if no headers)
        // Comment Option A above, and uncomment Option B below if you want fallback:
        /*
    this.$toastr.w(
      "No headers found in file. Falling back to default column mapping."
    );
    startRow = 0; // Data starts immediately
    columnIndex = {
      Symbol: 0,
      Quantity: 1,
      BuyDate: 2,
      BuyPrice: 3,
      TradeType: 4
    };
    */
      } else {
        switch (this.selectedBroker) {
          // case 1:
          //   startRow = 4;
          //   columnIndex.Symbol = 3;
          //   columnIndex.Quantity = 8;
          //   columnIndex.BuyDate = 2;
          //   columnIndex.BuyPrice = 10;
          //   break;
          // case 2:
          //   startRow = 1;
          //   columnIndex.Symbol = 1;
          //   columnIndex.Quantity = 3;
          //   columnIndex.BuyDate = 0;
          //   columnIndex.BuyPrice = 4;
          //   break;
          // case 3:
          //   startRow = 3;
          //   columnIndex.Symbol = 0;
          //   columnIndex.Quantity = 1;
          //   columnIndex.BuyDate = 2;
          //   columnIndex.BuyPrice = 4;
          //   break;
          case 4:
            if (data[14]) {
              startRow = 15;
              columnIndex.Symbol = data[14].findIndex((item) =>
                item.toLowerCase().includes("symbol")
              );
              columnIndex.Quantity = data[14].findIndex((item) =>
                item.toLowerCase().includes("quantity")
              );
              columnIndex.BuyDate = data[14].findIndex(
                (item) =>
                  item.toLowerCase().includes("trade_date") ||
                  item.toLowerCase().includes("date") ||
                  item.toLowerCase().includes("buydate") ||
                  item.toLowerCase().includes("Trade Date")
              );
              columnIndex.BuyPrice = data[14].findIndex(
                (item) =>
                  item.toLowerCase().includes("price") ||
                  item.toLowerCase().includes("buyprice")
              );
              columnIndex.TradeType = data[14].findIndex(
                (item) =>
                  item.toLowerCase().includes("trade_type") ||
                  item.toLowerCase().includes("type") ||
                  item.toLowerCase().includes("Trade Type")
              );
            } else {
              startRow = 1;
              columnIndex.Symbol = data[0].findIndex((item) =>
                item.toLowerCase().includes("symbol")
              );
              columnIndex.Quantity = data[0].findIndex((item) =>
                item.toLowerCase().includes("quantity")
              );
              columnIndex.BuyDate = data[0].findIndex(
                (item) =>
                  item.toLowerCase().includes("trade_date") ||
                  item.toLowerCase().includes("date") ||
                  item.toLowerCase().includes("buydate")
              );
              columnIndex.BuyPrice = data[0].findIndex(
                (item) =>
                  item.toLowerCase().includes("price") ||
                  item.toLowerCase().includes("buyprice")
              );
              columnIndex.TradeType = data[0].findIndex(
                (item) =>
                  item.toLowerCase().includes("trade_type") ||
                  item.toLowerCase().includes("type")
              );
            }
            break;

          case 5:
            startRow = 1;
            columnIndex.Symbol = data[0].findIndex((item) =>
              item.toLowerCase().includes("symbol")
            );
            columnIndex.Quantity = data[0].findIndex((item) =>
              item.toLowerCase().includes("quantity")
            );
            columnIndex.BuyDate = data[0].findIndex(
              (item) =>
                item.toLowerCase().includes("buydate") ||
                item.toLowerCase().includes("date")
            );
            columnIndex.BuyPrice = data[0].findIndex(
              (item) =>
                item.toLowerCase().includes("buyprice") ||
                item.toLowerCase().includes("price")
            );
            columnIndex.TradeType = data[0].findIndex((item) =>
              item.toLowerCase().includes("type")
            );
            break;
          default:
        }
        formatError =
          Object.values(columnIndex).includes(-1) ||
          Object.values(columnIndex).includes(null);
        if (formatError) {
          this.$toastr.e(
            "The file is different from the expected format. Please see the sample file headers and upload accordingly."
          );
        }
        if (!formatError) {
          for (var i = startRow; i < data.length; i++) {
            const { Symbol, Quantity, BuyDate, BuyPrice, TradeType } =
              columnIndex;
            let p = {
              Symbol: "",
              Quantity: "",
              BuyDate: "",
              BuyPrice: "",
              SlNo: i,
            };
            if (data[i].length > 0) {
              const symbolModified =
                data[i][Symbol] === undefined ? "" : data[i][Symbol].toString();
              p.Symbol = symbolModified.trim();
              p.Quantity = this.formatQuantity(data[i], Quantity, TradeType);
              p.BuyDate = this.formatDate(data[i][BuyDate]);
              p.BuyPrice = this.parseBuyPrice(data[i][BuyPrice]);
              a.push(p);
            }
          }
          this.showImportTransactions = false;
          this.holdingsJson = a;
          this.holdingsJsonCount = this.holdingsJson.length;
          this.validateHoldings(true);
          this.selectedBroker = 5;
          this.$refs.importTransactions.value = "";
          this.showGenerateReportButton = true;
          this.holdingsJson.forEach((row, index) => {
            if (
              row.Symbol &&
              row.BuyDate &&
              (row.BuyPrice === "" || row.BuyPrice === null || row.BuyPrice === undefined)
            ) {
              this.updatePriceByDate(index, row.BuyDate);
            }
          });
          // this.sendTransactionData(a);
        }
      }
    },

    async processBrokerUserData(userHoldings, isSecondTimeCall) {
      if (userHoldings == null) {
        if (isSecondTimeCall == true) {
          this.$toastr.e(
            "Your holdings data is unavailable.please check with anandrathi broker."
          );
        } else {
          if (this.userData.isBrokerAdminUser) {
            await this.getBrokerAdminToken(this.arClientCode).then(
              (response) => {
                this.getUserCurrentHoldings(true);
              }
            );
          } else {
            await this.getBrokerToken().then((response) => {
              this.getUserCurrentHoldings(true);
            });
          }
        }
      } else {
        this.$toastr.removeByName("symbol-error");
        this.$toastr.removeByName("quantity-error");
        this.$toastr.removeByName("price-error");
        let a = [];
        userHoldings.forEach(function (obj, index) {
          let p = {
            Symbol: "",
            Quantity: "",
            BuyDate: "",
            BuyPrice: "",
            SlNo: index + 1,
          };
          p.Symbol = obj.scheme_nam.trim();
          p.Quantity = obj.Qty;
          p.BuyDate = "2021-04-05";
          p.BuyPrice = obj.AvgPrice;
          a.push(p);
        });
        this.showImportTransactions = false;
        this.holdingsJson = a;
        this.holdingsJsonCount = this.holdingsJson.length;
        this.validateHoldings(true);
        this.selectedBroker = 5;
        if (localStorage.getItem("postPaymentReportGenerate") == "true") {
          this.getReportData(1);
          localStorage.removeItem("postPaymentReportGenerate");
        }
        this.showGenerateReportButton = true;
      }
    },

    sendTransactionData(data) {
      const loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      this.$refs.importTransactions.value = "";
      this.showSubmitBtn = false;
      this.showdeletefilebtn = false;
      const formData = new FormData();
      formData.append("transaction_data", JSON.stringify(data));
      this.$http
        .post(API_URL + "holdings_from_transactions", formData, {
          headers: {
            Authorization: `Basic ${btoa(
              unescape(
                encodeURIComponent(
                  `${localStorage.getItem("access_token")}:` + ""
                )
              )
            )}`,
          },
        })
        .then((response) => {
          loader.hide();
          // Session Expired
          if (response.status === 401) {
            /* this.$router.push({
              name: "Logout"
            }); */
          }
          if (!response.data && response.data.status != 200) {
            this.$toastr.e(
              "Upload failed. Please check your transactions file and then try again."
            );
          } else {
            var self = this;
            this.reset();
            if (response.data) {
              this.transactionData.BestExclusions =
                response.data[0].BestExclusions;
              this.transactionData.BestWinners = response.data[0].BestWinners;
              this.transactionData.WorstExclusions =
                response.data[0].WorstExclusions;
              this.transactionData.WorstLosers = response.data[0].WorstLosers;
              this.setTransactionData(this.transactionData);
            }
            response.data &&
              response.data[0].InputData.forEach(function (obj) {
                obj.BuyDate = moment(obj.PriceDate).format("YYYY-MM-DD");
                self.holdingsJson.push(obj);
              });
            this.holdingsJsonCount = this.holdingsJson.length;
            this.validateHoldings(true);
          }
        })
        .catch((e) => {
          //   loader.hide();
          loader.hide();
          if (e.response.status === 401) {
            // Session Expired
            /* this.$router.push({
              name: "Logout"
            }); */
            this.$toastr.e(
              "An unknown error occured. Please try again, or contact a developer for assistance."
            );
          } else if (e.response.status === 400) {
            // Wrong File
            this.$toastr.e(
              "Incorrect data, Please upload CSV File as sample file."
            );
          } else {
            /* this.$router.push({
              name: "Logout"
            }); */
            this.$toastr.e(
              "An unknown error occured.Please try again, or contact a developer for assistance."
            );
          }
        });
    },

    formatDate(date) {
      if (this.selectedBroker == 1) {
        return moment(date).utcOffset("+05:30").format("YYYY-MM-DD");
      } else if (this.selectedBroker == 2) {
        return moment(this.julianIntToDate(date))
          .utcOffset("+05:30")
          .format("YYYY-MM-DD");
      } else if (this.selectedBroker == 4) {
        return moment(date).utcOffset("+05:30").format("YYYY-MM-DD");
      } else if (this.selectedBroker == 5) {
        return moment(this.excelDateToJSDate(date))
          .utcOffset("+05:30")
          .format("YYYY-MM-DD");
      }
      return date;
    },

    excelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
    },

    formatQuantity(row, index) {
      row[2] = row[2] === undefined ? "" : row[2];
      row[4] = row[4] === undefined ? "" : row[4];
      row[5] = row[5] === undefined ? "" : row[5];
      row[6] = row[6] === undefined ? "" : row[6];
      let quantity = `${row[index]}`;
      if (this.selectedBroker == 2) {
        quantity = `${row[2].toLowerCase() == "sell" ? "-" : ""}${row[index]}`;
      } else if (this.selectedBroker == 1) {
        quantity = `${row[9] == 0 ? "-" : ""}${row[index]}`;
      } else if (this.selectedBroker == 4) {
        if (this.transactionfile.name.includes(".csv")) {
          if (!row[index].toString().includes("-")) {
            quantity = `${
              row[6].toLowerCase() == "sell" ? "-" : ""
            }${Math.trunc(row[index])}`;
          }
        } else {
          if (!row[index].toString().includes("-")) {
            quantity = `${
              row[6].toLowerCase() == "sell" ? "-" : ""
            }${Math.trunc(row[index])}`;
          }
        }
      } else if (this.selectedBroker == 5) {
        if (row[index] && !row[index].toString().includes("-")) {
          quantity = `${
            row[4].toString().trim().toLowerCase() == "sell" ? "-" : ""
          }${Math.trunc(row[index])}`;
        }
      } else {
        quantity = `${row[index]}`;
      }
      return quantity;
    },

    julianIntToDate(jd) {
      return moment("01.01.1900", "DD-MM-YYYY")
        .add(parseInt(jd) - 2, "days")
        .format("YYYY-MM-DD");
    },

    loadHandler(event) {
      var csv = event.target.result;
      this.process(csv);
    },

    cancelModal(data) {
      // this.selectedBroker = null;
      // this.$refs.importTransactions.value = "";
      this.didBrokerManualImport = this.userData.isBrokerAdminUser ? true : false;
      this.showSubmitBtn = false;
      this.showdeletefilebtn = false;
      this.showShortSellError = false;
      this.showSymbolError = false;
      this.transactionBtnText = "Choose File";
      this.showTransaction = false;
      this.showConfirmationPopup = false;
      this.allowShortSell = 0;
      if (this.didBrokerManualImport == true && !this.userModalCanceled) {
        this.username = "";
        localStorage.setItem("arClientName", this.userData.name);
        this.brokerMaualTransaction = data;
        this.showUserModal = true;
        console.log("showing modal", this.selectedBroker);
      } else if (!this.userModalCanceled && this.isXLXS) {
        if(this.selectedBroker===5){
         this.processTransaction(data);
        } else {
          this.resetformat()
        }
      } else if (!this.userModalCanceled && !this.isXLXS) {
        if(this.selectedBroker===4){
         this.parseCSV(data);;
        } else {
           this.resetformat()
        }
      } else {
        this.userModalCanceled = false;
      }
    },
    handleOk() {
      localStorage.setItem("arClientName", this.username);
      if (this.isXLXS) {
        this.processTransaction(this.brokerMaualTransaction);
      } else {
        this.parseCSV(this.brokerMaualTransaction);
      }
      this.showUserModal = false;
      this.userModalCanceled = false;
    },

    handleCancel() {
      this.showUserModal = false;
      this.userModalCanceled = true;
      this.showImportTransactions = false;
      this.isXLXS = false;
    },

    resetformat(){
      this.isXLXS = false;
      this.$toastr.w(
            "Please ensure that the uploaded file is in the correct format as per the sample file."
          );
    },

    handleSkip() {
      if (this.isXLXS) {
        this.processTransaction(this.brokerMaualTransaction);
      } else {
        this.parseCSV(this.brokerMaualTransaction);
      }
      this.showUserModal = false;
      this.userModalCanceled = false;
    },

    onModalHidden(evt) {
      // ✅ Runs only when modal is closed by ESC or clicking outside
    },

    allowShortSellAction(action) {
      this.allowShortSell = 1;
      this.submit();
    },
    allowSymbolErrorAction() {
      this.showSymbolError = false;
      this.$toastr.removeByName("symbol-error");
      let newHoldingsJson = this.holdingsJson;
      self = this;
      for (var i = 0; i < this.symbolErrorSlNo.length; i++) {
        this.holdingsJson.forEach(function (objj, indexx) {
          if (self.symbolErrorSlNo[i] == objj.SlNo)
            newHoldingsJson.splice(indexx, 1);
        });
      }
      this.holdingsJson = newHoldingsJson;
      this.holdingsJson.forEach(function (obj, indexx) {
        obj.SlNo = indexx + 1;
        $(`#${indexx + 1}Symbol`).removeClass("errorCellClass");
        $(`#${indexx + 1}BuyDate`).removeClass("errorCellClass");
      });
      this.submit();
    },

    process(csv) {
      // Newline split
      var lines = csv.split("\n");
      var headers = ["Symbol", "Quantity", "BuyDate", "BuyPrice"];
      this.holdingsJson = [];

      var max = 0;
      if (lines.length <= 2) {
        max = lines.length;
      } else {
        max = lines.length - 1;
      }

      for (var i = 1; i < max; i++) {
        var obj = {};

        //Comma split
        var currentline = lines[i].split(",");
        for (var j = 0; j < headers.length; j++) {
          if (currentline[j] === undefined) {
            currentline[j] = "";
          }
          if (headers[j] == "BuyDate") {
            if (currentline[j] === undefined || currentline[j] == "") {
              currentline[j] = "";
            } else {
              currentline[j] = this.dateDMYtoYMD(currentline[j]);
            }
          }
          obj[headers[j]] = currentline[j];
        }
        this.holdingsJson.push(obj);
        this.holdingsJsonCount = this.holdingsJson.length;
        this.validateHoldings(true);
      }
    },

    errorHandler(evt) {
      if (evt.target.error.name == "NotReadableError") {
        alert("Cannot read your file !");
      }
    },

    async submit() {
      localStorage.setItem(
        "preLoginHoldingsData",
        JSON.stringify(this.holdingsJson)
      );
      var self = this;
      var msg = "";
      var isPremium = 0;
      if (this.reEvaluatePortfolioData != null) {
        isPremium = this.reEvaluatePortfolioData.isPremium;
        if (isPremium == 0 && this.userData.isScUser === 1) {
          announceToScreenReader(
            "All available reports have been exhausted. Please contact our team for further access."
          );
          this.$dialog.alert(
            "All available reports have been exhausted. Please contact our team for further access.",
            { okText: "OK" }
          );
          return;
        }
        self.getReportData(isPremium);
      } else {
        var options = {
          okText: "Yes",
          cancelText: "Continue with Free Report",
        };
        if (this.isMSIUser) {
          isPremium = parseInt(localStorage.getItem("isPremium"));
          self.getReportData(isPremium);
        } else {
          await this.fetchusersubscription();
          if (
            this.userData.isBrokerUser &&
            this.userData.userType != this.brokerType.AnandRathiUserGuest
          ) {
            options.cancelText = "Cancel";
          }
          if (
            this.userData.userType != 3 &&
            this.userSubscription &&
            this.userSubscription.remainingAccess > 0
          ) {
            if (this.userData.isScUser === 1) {
              msg =
                "You have " +
                this.userSubscription.remainingAccess +
                " report(s) left in your account. Do you want to proceed?";

              announceToScreenReader(msg);
              this.$dialog
                .confirm(msg, {
                  okText: "Yes",
                  cancelText: "No",
                })
                .then(() => {
                  isPremium = 1;
                  self.getReportData(isPremium);
                })
                .catch(() => {
                  // ❌ NO clicked — do nothing, just close
                });

              return;
            }
            msg =
              "You have " +
              this.userSubscription.remainingAccess +
              " Premium Report(s) left out, Do you want to proceed with Premium report?";

            if (
              this.userData.isBrokerUser &&
              this.userData.userType != this.brokerType.AnandRathiUserGuest
            ) {
              isPremium = 1;
              self.getReportData(isPremium);
            } else {
              announceToScreenReader(msg);
              this.$dialog
                .confirm(msg, options)
                .then(function () {
                  isPremium = 1;
                  self.getReportData(isPremium);
                })
                .catch(function () {
                  if (
                    !self.userData.isBrokerUser ||
                    self.userData.userType !=
                      this.brokerType.AnandRathiUserGuest
                  ) {
                    isPremium = 0;
                    self.getReportData(isPremium);
                  }
                });
            }
          } else {
            if (
              this.userData.isBrokerUser &&
              this.userData.userType != this.brokerType.AnandRathiUserGuest
            ) {
              self.$router.push("/plandetails");
            } else {
              if (this.userData.isScUser === 1) {
                announceToScreenReader(
                  "All available reports have been exhausted. Please contact our team for further access."
                );
                this.$dialog.alert(
                  "All available reports have been exhausted. Please contact our team for further access.",
                  {
                    okText: "OK",
                  }
                );
                return;
              }

              if (
                this.userData.isBrokerUser &&
                this.userData.userType != this.brokerType.AnandRathiUserGuest
              ) {
                self.$router.push("/plandetails");
              } else {
                msg =
                  this.userData.userType == 3
                    ? "This is a free report. Kindly open an account to access the full report."
                    : "You have Basic access right now, Do you want to proceed with Premium access?";

                if (this.userData.userType == 3) {
                  options = {
                    cancelText: "Free Report",
                    customClass: "okButtonDisable",
                  };
                }

                announceToScreenReader(msg);
                this.$dialog
                  .confirm(msg, options)
                  .then(function () {
                    self.$router.push("/plandetails");
                  })
                  .catch(function () {
                    isPremium = 0;
                    self.getReportData(isPremium);
                  });
              }
            }
          }
        }
      }
    },

    async getReportData(isPremium) {
      this.$toastr.removeByName("symbol-error");
      this.$toastr.removeByName("quantity-error");
      this.$toastr.removeByName("price-error");
      this.holdingsJson.forEach(function (obj, index) {
        $(`#${index + 1}Symbol`).removeClass("errorCellClass");
        $(`#${index + 1}BuyDate`).removeClass("errorCellClass");
      });

      this.$v.$touch();

      if (this.$v.invalid) {
        return;
      }

      //if (userPortfolioCSV.files[0] != undefined) {
      if (this.holdingsJson.length > 0) {
        const loader = this.$loading.show({
          // Optional parameters
          container: this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel,
        });

        this.holdingsJson = _.each(this.holdingsJson, function (o) {
          _.each(o, function (v, k) {
            if (k === "BuyPrice") {
              v = v.toString();
            }
            o[k] = typeof v == "string" ? v.trim() : v;
          });
        });
        this.$toastr.Add({
          name: "loadingAlert", // this is give you ability to use removeByName method
          msg: "Please wait while we generate your report, which might take some time due to the in-depth calculations and analysis involved.",
          type: "info", // Toast type,
          position: "toast-top-full-width",
          clickClose: true, // Click Close Disable
          timeout: 0,
          showCloseButton: true,
        });
        const formData = new FormData();
        formData.append(
          "user_portfolio_data",
          JSON.stringify(this.holdingsJson)
        );
        if (
          this.userData.isBrokerUser == 1 &&
          this.userData.userType != this.brokerType.AnandRathiUserGuest
        ) {
          this.selectedPortfolioId =
            API_URL == "https://portfoliosmith.in/api/" ? 22 : 7;
        }
        formData.append("portfolio_id", this.selectedPortfolioId);
        formData.append("rec_id", this.selectedRecommId);
        formData.append("cash", this.cash);
        formData.append("allowShortSell", this.allowShortSell);
        formData.append("is_premium", isPremium);
        formData.append(
          "client_id",
          this.userData.isBrokerUser == 1 && this.userData.userType == 3 ? 4 : 1
        );
        await this.generateReport(formData)
          .then((response) => {
            this.$toastr.removeByName("loadingAlert");
            this.allowShortSell = 0;
            isPremium == 1
              ? this.setTab("TradingAnalysis")
              : this.setTab("Portfolio");
            // this.initiateCallback();
            loader.hide();
            // Session Expired
            if (response.status === 401) {
              /* this.$router.push({
                name: "Logout"
              }); */
            }
            // Handling Bad Response
            if (!response.data && response.data.status != 200) {
              this.$toastr.e(
                "Upload failed. Please check your CSV file and then try again."
              );
            } else {
              if (response.data[0] && response.data[0].CurrentDateError) {
                let slNo = "";
                for (var i = 0; i < response.data[0].SerialNo.length; i++) {
                  $(`#${response.data[0].SerialNo[i]}BuyDate`).addClass(
                    "errorCellClass"
                  );
                  slNo =
                    slNo === ""
                      ? response.data[0].SerialNo[i]
                      : slNo + " ," + response.data[0].SerialNo[i];
                }
                this.$toastr.Add({
                  name: "price-error", // this is give you ability to use removeByName method
                  msg: response.data[0].CurrentDateError,
                  type: "error", // Toast type,
                  position: "toast-top-full-width",
                  clickClose: true, // Click Close Disable
                  timeout: 0,
                });
                return;
              } else if (response.data[0] && response.data[0].ShortSellError) {
                // this.$toastr.e(response.data[0].ShortSellError);
                let slNo = "";
                for (var i = 0; i < response.data[0].SerialNo.length; i++) {
                  $(`#${response.data[0].SerialNo[i]}Symbol`).addClass(
                    "errorCellClass"
                  );
                  slNo =
                    slNo === ""
                      ? response.data[0].SerialNo[i]
                      : slNo + " ," + response.data[0].SerialNo[i];
                }
                this.openShortSellError(response.data[0].ShortSellError);
                return;
              } else if (response.data[0] && response.data[0].EmptyPortfolio) {
                this.$toastr.e(response.data[0].EmptyPortfolio);
                return;
              } else if (response.data[0] && response.data[0].SymbolError) {
                let slNo = "";
                for (var i = 0; i < response.data[0].SerialNo.length; i++) {
                  $(`#${response.data[0].SerialNo[i]}Symbol`).addClass(
                    "errorCellClass"
                  );
                  slNo =
                    slNo === ""
                      ? response.data[0].SerialNo[i]
                      : slNo + " ," + response.data[0].SerialNo[i];
                }
                this.openSymbolError(response.data[0].SerialNo);
                this.$toastr.Add({
                  name: "symbol-error", // this is give you ability to use removeByName method
                  msg: response.data[0].SymbolError + ". Review SlNo." + slNo,
                  type: "error", // Toast type,
                  position: "toast-top-full-width",
                  clickClose: true, // Click Close Disable
                  timeout: 0,
                });
                return;
              } else if (response.data[0] && response.data[0].WeekendError) {
                let slNo = "";
                for (var i = 0; i < response.data[0].SerialNo.length; i++) {
                  $(`#${response.data[0].SerialNo[i]}BuyDate`).addClass(
                    "errorCellClass"
                  );
                  slNo =
                    slNo === ""
                      ? response.data[0].SerialNo[i]
                      : slNo + " ," + response.data[0].SerialNo[i];
                }
                this.$toastr.Add({
                  name: "price-error", // this is give you ability to use removeByName method
                  msg: response.data[0].WeekendError + ". Review SlNo." + slNo,
                  type: "error", // Toast type,
                  position: "toast-top-full-width",
                  clickClose: true, // Click Close Disable
                  timeout: 0,
                  showCloseButton: true,
                });
                return;
              } else if (
                response.data[0] &&
                response.data[0].EmptyPortfolioError
              ) {
                let slNo = "";
                for (var i = 0; i < response.data[0].SerialNo.length; i++) {
                  $(`#${response.data[0].SerialNo[i]}Symbol`).addClass(
                    "errorCellClass"
                  );
                  slNo =
                    slNo === ""
                      ? response.data[0].SerialNo[i]
                      : slNo + " ," + response.data[0].SerialNo[i];
                }
                this.$toastr.Add({
                  name: "symbol-error", // this is give you ability to use removeByName method
                  msg: response.data[0].EmptyPortfolioError,
                  type: "error", // Toast type,
                  position: "toast-top-full-width",
                  clickClose: true, // Click Close Disable
                  timeout: 0,
                });
                return;
              }

              const portfolioData = {
                client: this.client,
                BrokerOrModelForRecomm: this.brokerOrModelForRecomm,
                BrokerOrModelForPortfolio: this.brokerOrModelForPortfolio,
                HoldingsData: JSON.stringify(this.holdingsJson),
                SelectedRecomm: this.selectedRecommId,
                SelectedModelPortfolio: this.selectedPortfolioId,
                Cash: this.cash,
              };

              localStorage.setItem("client", this.client);
              localStorage.setItem(
                "BrokerOrModelForRecomm",
                this.brokerOrModelForRecomm
              );
              localStorage.setItem(
                "BrokerOrModelForPortfolio",
                this.brokerOrModelForPortfolio
              );
              localStorage.setItem(
                "HoldingsData",
                JSON.stringify(this.holdingsJson)
              );
              localStorage.setItem("SelectedRecomm", this.selectedRecommId);
              localStorage.setItem(
                "SelectedModelPortfolio",
                this.selectedPortfolioId
              );
              const repObj = [
                {
                  transaction_analysis: response.data[0].transaction_analysis,
                  user_portfolio_ranking:
                    response.data[0].user_portfolio_ranking,
                  user_portfolio: response.data[0].user_portfolio,
                },
              ];
              localStorage.setItem("PsiReportJson", JSON.stringify(repObj));
              localStorage.setItem("Cash", this.cash);
              this.loaded = true;
              loader.hide();
              if (
                isPremium == 1 &&
                this.reEvaluatePortfolioData == null &&
                !this.isMSIUser
              ) {
                this.updateUserSubscription();
              }
              response.data = eval(response.data);
              this.setAlphaScopeData(response.data);
              this.setPortfolio(portfolioData);
              this.setEnableReport(true);
              this.setGeneratedReportType(isPremium);
              localStorage.setItem("autoDownloadReport", true);
              console.log("Report Generated Successfully", response.data);
              if (
                this.userData.isScUser === 1 &&
                this.userSubscription.remainingAccess > 0
              ) {
                this.getscresopnce(response.data);
              }
            }
          })
          .catch((e) => {
            this.$toastr.removeByName("loadingAlert");
            loader.hide();
            this.allowShortSell = 0;
            if (e.response && e.response.status === 401) {
              // Session Expired
              /* this.$router.push({
                name: "Logout"
              }); */
              this.$toastr.e(
                "An unknown error occured. Please try again, or contact a developer for assistance."
              );
            } else if (e.response.status === 400) {
              // Wrong File
              this.$toastr.e(
                "Incorrect data, Please upload CSV File as sample file."
              );
            } else {
              /* this.$router.push({
                name: "Logout"
              }); */
              this.$toastr.e(
                "An unknown error occured.Please try again, or contact a developer for assistance."
              );
            }
          });
      }
    },

    // make sure axios is available: import axios from 'axios' or window.axios
    async getscresopnce(response) {
      const safeGetLocal = (key, maxLen = 20000) => {
        try {
          const v = localStorage.getItem(key);
          if (!v) return null;
          if (typeof v !== "string") return String(v).slice(0, maxLen);
          if (v.length > maxLen) return null;
          return v;
        } catch (e) {
          console.warn(`safeGetLocal error for ${key}`, e);
          return null;
        }
      };

      const holdingsData = safeGetLocal("HoldingsData");
      const psiJson = safeGetLocal("PsiReportJson");

      /* ----------------------------
     Normalize input / output
  ----------------------------- */

      /* ----------------------------
     2️⃣ Create initial report
  ----------------------------- */
      const createPayload = {
        reportUrl: "",
        fileName,
        isPremium: 1,
        inputData: holdingsData,
        outputData: null,
        comments: "",
        pptUrl: "",
        xlsxUrl: "",
      };

      const createRes = await this.postPdfDownloadSuccess(createPayload);

      if (!createRes?.data?.response?.success) {
        console.error("Failed to create report", createRes);
        return;
      }

      /* ----------------------------
     1️⃣ Generate SC Report
  ----------------------------- */
      const scResult = await this.standardCharteredReport(response);

      if (!scResult?.data?.success || !scResult?.data?.cloudFiles) {
        console.warn("Invalid Standard Chartered Response", scResult);
        return;
      }

      const { pptUrl, xlsxUrl } = scResult.data.cloudFiles;

      if (!pptUrl && !xlsxUrl) {
        console.warn("No cloud files returned", scResult.data.cloudFiles);
        return;
      }

      const fileName = this.sanitizeFileName(
        decodeURIComponent(
          String(pptUrl || xlsxUrl)
            .split("/")
            .pop()
        )
      );

      /* ----------------------------
     3️⃣ Update report with URLs
  ----------------------------- */

      const inputData =
        holdingsData == null
          ? '[{"Data":"input data not found"}]'
          : holdingsData;

      const outputData =
        psiJson == null ? '[{"Data":"output data not found"}]' : psiJson;

      const updatePayload = {
        id: createRes.data.response.report.id,
        reportUrl: null,
        pptUrl: pptUrl || null,
        xlsxUrl: xlsxUrl || null,
        fileName,
        isPremium: 1,
        inputData,
        outputData,
        comments: "",
      };

      try {
        await this.updatePostPdfDownload(updatePayload);
        console.log("Report updated successfully");
      } catch (err) {
        console.error("Failed to update report", err);
      }
    },

    // reuse your sanitizer
    sanitizeFileName(name) {
      if (!name) return "";
      return String(name)
        .replace(/[^a-zA-Z0-9._-]/g, "_")
        .replace(/_+/g, "_")
        .trim();
    },

    showOldReport() {
      this.setEnableReport(true);
    },

    onCancel() {},

    checkCellError(type, value) {
      if (type === "price") {
        if (value === "" || value === "undefined") return true;
        else {
          return false;
        }
      } else if (type === "quantity") {
        if (
          value === "" ||
          value === "undefined" ||
          value === null ||
          isNaN(value) ||
          Number(value) === 0
        )
          return true;
        else {
          return false;
        }
      } else if (type === "symbol") {
        if (value === "" || value === "undefined") return true;
        else {
          return false;
        }
      } else if (type === "buyDate") {
        if (value === "" || value === "undefined") return true;
        else {
          return false;
        }
      } else {
        return false;
      }
    },
    getTextBoxId(index, type) {
      if (type === "Symbol") return `${index + 1}Symbol`;
      else if (type === "BuyDate") return `${index + 1}BuyDate`;
    },
    async getUserCurrentHoldings(isSecondTimeCall) {
      if (this.userData.isBrokerAdminUser) {
        await this.isRegisteredBrokerUserCall({
          utmParam:
            "utm_source=AnandRathi&utm_client_code=" + this.arClientCode,
        }).then((respnse) => {
          if (respnse.isBrokerUserExists) {
            this.didBrokerManualImport = false;
            localStorage.setItem("arClientCode", this.arClientCode);
            localStorage.setItem("arClientName", respnse.name);
            this.getBrokerAdminUserHoldings({
              brokerToken: localStorage.getItem("brokerToken"),
              clientCode: this.arClientCode,
            }).then((response) => {
              if (!response.data && response.data.status != 200) {
                this.$toastr.e(
                  "An unknown error occured while fetching Broker User Current Holdings"
                );
              } else {
                const userHoldings = JSON.parse(
                  response.data.response.brokerUserHoldings
                );
                this.processBrokerUserData(userHoldings, isSecondTimeCall);
              }
            });
          } else {
            this.$toastr.e(
              "User with entered clientcode is not a registered user. Please register user and import holdings."
            );
            return false;
          }
        });
      } else {
        await this.getBrokerUserHoldings({
          brokerToken: localStorage.getItem("brokerToken"),
        }).then((response) => {
          if (!response.data && response.data.status != 200) {
            this.$toastr.e(
              "An unknown error occured while fetching Broker User Current Holdings"
            );
          } else {
            const userHoldings = JSON.parse(
              response.data.response.brokerUserHoldings
            );
            this.processBrokerUserData(userHoldings, isSecondTimeCall);
          }
        });
      }
    },
    async updateUserSubscription() {
      await this.updateSubscription().then((response) => {
        if (!response.data && response.data.status != 200) {
          this.$toastr.e(
            "An unknown error occured while updating subscription"
          );
        } else {
        }
      });
    },
    addStockModalClick() {
      this.addNewmodalShow = !this.addNewmodalShow;
      this.newStock = {
        symbol: "",
        quantity: "",
        buyDate: "",
        buyPrice: "",
        tradeType: "Buy",
      };
    },

    addNewStock() {
      if (this.validNewStock() === true) {
        this.holdingsJson.push({
          Symbol: this.newStock.symbol,
          Quantity: this.newStock.quantity,
          BuyDate: this.newStock.buyDate,
          BuyPrice: this.newStock.buyPrice,
          SlNo: this.holdingsJson.length + 1,
        });
        this.addNewmodalShow = false;
        this.newStock = {
          symbol: "",
          quantity: "",
          buyDate: "",
          buyPrice: "",
          tradeType: "Buy",
        };
        this.validTable = true;
        this.validRow = true;
      }
    },
    validNewStock() {
      if (this.addNewmodalShow) {
        if (
          !this.validateSymbolResponsive(this.newStock.symbol) &&
          !this.validateQuantityResponsive(this.newStock.quantity) &&
          !this.validatePriceResponsive(this.newStock.buyPrice) &&
          this.newStock.symbol != "" &&
          this.newStock.quantity != "" &&
          this.newStock.buyPrice != "" &&
          this.newStock.buyDate != ""
        ) {
          return true;
        } else false;
      } else false;
    },

    dateDisabled(ymd, date) {
      date = moment(date);
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.day();
      // const day = date.getDate()
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },

    is_weekend(date1) {
      var dt = moment(date1);
      if (dt.day() == 6 || dt.day() == 0) {
        return true;
      }
      return false;
    },

    updateStartDate(event) {
      this.startDate = event;
    },

    updateEndDate(event) {
      this.endDate = event;
    },

    changeUserPortfolio(e) {
      this.selectedMSIPortfolioId = e;
    },

    async checkEsignStatus() {
      try {
        const userId = localStorage.getItem("uid");
        const productType = "psi";
        const response = await axios.get(
          "https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/user/isEsignDone.json",
          {
            params: { userId, productType },
          }
        );

        const responseData = response?.data?.data;

        if (responseData?.success === false) {
          this.esignRecord = {
            id: responseData.id ?? null,
            UserId: responseData.UserId ?? null,
            product: responseData.product ?? null,
            transactionId: responseData.transactionId ?? null,
            pdflink: responseData.pdflink ?? null,
            createdDate: responseData.createdDate ?? null,
            updatedDate: responseData.updatedDate ?? null,
          };
          this.fetchAgreement();
          this.showEsign = true;
        } else {
          this.showEsign = false;
        }
      } catch (error) {}
    },

    async fetchAgreement() {
      try {
        const response = await axios.get(
          "https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/userlegalagreement/agreementtype.json",
          {
            params: {
              productCode: "psi",
              agreementtype: 3,
            },
          }
        );
        this.legalAgreementContentEsign = response.data.data.description;
        this.isEsignActive = response.data.data.isEsign === 1;
      } catch (error) {}
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/AddHoldings.js